module.exports = __webpack_public_path__ + "static/img/HONSBERG.3529e3a0.png";